export interface SmsProtection {
  phoneCooldownSeconds: number;
  phonePer10Minutes: number;
  phonePer24Hours: number;
  ipPer10Minutes: number;
  accountPer24Hours: number;
  globalPer24Hours: number;
}
export const smsProtectionRanges: Record<keyof SmsProtection, [number, number]> = {
  phoneCooldownSeconds: [30, 3600],
  phonePer10Minutes: [1, 10],
  phonePer24Hours: [1, 50],
  ipPer10Minutes: [1, 1000],
  accountPer24Hours: [1, 10000],
  globalPer24Hours: [1, 100000],
};
